
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteT as ObiOwnShipRemoteTElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-t.js';
 
 
 

 
 export const ObiOwnShipRemoteT = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-t',
   elementClass: ObiOwnShipRemoteTElement,
   events: {
     
   }
  });
 
 